<template>
  <b-card>
    <!-- media -->

    <!-- form -->
    <validation-observer
      v-slot="{ invalid, validate }"
      ref="employeeBankDetailsValidation"
    >
      <b-form class="mt-2" @submit.prevent>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Bank Name" label-for="bankName">
              <validation-provider
                #default="{ errors }"
                name="Bank Name"
              >
                <b-form-select
                  :options="bankNameOptions"
                  placeholder="Select Bank"
                  v-model="employeeDetail.bankName"
                  :disabled="!isEdit"
                  :state="errors.length > 0 ? false : null"
                />
                <small v-if="errors.length" class="text-danger text-end">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group label="Account Number" label-for="accountNumber">
              <validation-provider
                #default="{ errors }"
                name="Account Number"
              >
                <b-form-input
                  name="accountNumber"
                  placeholder="Account Number"
                  type="number"
                  v-model="employeeDetail.accountNumber"
                  :disabled="!isEdit"
                  :state="errors.length > 0 ? false : null"
                />
                <small v-if="errors.length" class="text-danger text-end">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Swift Code" label-for="swiftCode">
              <validation-provider
                #default="{ errors }"
                name="Swift Code"
              >
                <b-form-input
                  name="swiftCode"
                  placeholder="Swift Code"
                  v-model="employeeDetail.swiftCode"
                  :disabled="!isEdit"
                  :state="errors.length > 0 ? false : null"
                  @keypress="preventSpecialChars"
                  @paste="handlePaste"
                />
                <small v-if="errors.length" class="text-danger text-end">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Branch" label-for="branch">
              <validation-provider
                rules="valid-name"
                #default="{ errors }"
                name="branch"
              >
                <b-form-input
                  name="branch"
                  placeholder="Branch"
                  v-model="employeeDetail.branch"
                  :disabled="!isEdit"
                  :state="errors.length > 0 ? false : null"
                />
                <small v-if="errors.length" class="text-danger text-end">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BAvatar,
  BFormSelect,
  BFormDatepicker,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BAvatar,
    BFormSelect,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    employeeDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isEdit: false,
      required,
      optionsLocal: {
        username: "",
        fullName: "",
        email: "",
        company: "",
        avatar: "", // Provide a default value for avatar here
      },
      profileFile: null,
      bankNameOptions: [
  { value: "ABC Banking Corporation Ltd", text: "ABC Banking Corporation Ltd" },
  { value: "Absa Bank (Mauritius) Limited", text: "Absa Bank (Mauritius) Limited" },
  { value: "AfrAsia Bank Limited", text: "AfrAsia Bank Limited" },
  { value: "Bank of Baroda", text: "Bank of Baroda" },
  { value: "Bank One Limited", text: "Bank One Limited" },
  { value: "Banque Patronus Limitée", text: "Banque Patronus Limitée" },
  { value: "BCP Bank (Mauritius) Ltd", text: "BCP Bank (Mauritius) Ltd" },
  { value: "HSBC Bank (Mauritius) Limited", text: "HSBC Bank (Mauritius) Limited" },
  { value: "Investec Bank (Mauritius) Ltd", text: "Investec Bank (Mauritius) Ltd" },
  { value: "MauBank Ltd", text: "MauBank Ltd" },
  { value: "SBI (Mauritius) Limited", text: "SBI (Mauritius) Limited" },
  { value: "Silver Bank Limited", text: "Silver Bank Limited" },
  { value: "Standard Bank (Mauritius) Limited", text: "Standard Bank (Mauritius) Limited" },
  { value: "Standard Chartered Bank (Mauritius) Ltd", text: "Standard Chartered Bank (Mauritius) Ltd" },
  { value: "SBM Bank (Mauritius) Ltd", text: "SBM Bank (Mauritius) Ltd" },
  { value: "The Hongkong and Shanghai Banking Corporation Limited", text: "The Hongkong and Shanghai Banking Corporation Limited" },
  { value: "The Mauritius Commercial Bank Ltd", text: "The Mauritius Commercial Bank Ltd" },
],
    };
  },
  methods: {
   
    checkEditMode() {
      const currentPath = this.$route.path.toLowerCase();
      this.isEdit = !currentPath.includes("/view/");
    },
    preventSpecialChars(event) {
      const char = String.fromCharCode(event.keyCode);
      const pattern = /^[a-zA-Z0-9]$/;
      
      if (!pattern.test(char)) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      event.preventDefault();
      
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      
      const cleanedData = pastedData.replace(/[^a-zA-Z0-9]/g, '');
      this.employeeDetail.swiftCode = cleanedData;
    },
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
    async submitBankDetailsForm() {
      const isValid = await this.$refs.employeeBankDetailsValidation.validate();
      console.log("employeeBankDetailsValidation emitted: ", isValid);
      if (isValid) {
        this.$emit("employeeBankDetailsValidation", this.employeeDetail);
      }
      return isValid;
    },
  },
  // setup() {
  //   const refInputEl = ref(null);
  //   const previewEl = ref(null);

  //   const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl);.

  //   return {
  //     refInputEl,
  //     previewEl,
  //     inputImageRenderer,
  //   };
  // },
  mounted() {
    this.checkEditMode();
  },

  watch: {
    $route: "checkEditMode",
    // Watch for changes to the individual object
    employeeDetail: {
      handler(newVal) {
        // Emit the updated individual data to the parent
        // console.log("fo", newVal);
        this.$emit("updateBank", newVal);
      },
      deep: true, // Watch for nested changes in the individual object
    },
  },
};
</script>
